<script>
    import appConfig from '@src/app.config'
    import Layout from '@layouts/newdefaultform_unfluid'
    import PageHeader from '@components/page-header'
    import Spinner from '@components/spinner'
    import productManage from '@components/list-manage-product'
    import { giftlistApi } from '@router/apiFiles/giftlistApi'
    import { productApi } from '@router/apiFiles/productApi'
    import { priceApi } from '@router/apiFiles/priceApi'

    /**
     * Page
     */
    export default {
        page: {
            title: 'Adicionar produtos',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: {
            Layout, PageHeader, productManage, Spinner
        },
        data() {
            return {
                title: 'Adicionar produtos',
                items: [
                    {
                        text: 'LaVille',
                        href: '/',
                    },
                    {
                        text: 'Listas',
                        href: '/',
                    },
                    {
                        text: 'Adicionar produtos',
                        active: true,
                    },
                ],
                id: '',
                externalId: '',
                description: '',
                type: '',
                city: '',
                date: '',
                categoriesVisible: true,
                categories: [],
                page: 1,
                isBusy: false,
                currentCategory: '',
                currentDepartment: '',
                searchText: '',
                products: [],
                giftlistProducts: [],
                noProducts: false,
                giftlistSuggestionId: '',
                departmentTabIndex: 1,
                ordination: 1,
                reachEnd: true,
                scTimer: 0,
                scY: 0,
            }
        },
        mounted() {
            this.fetchData();
            this.scroll();
            window.addEventListener('scroll', this.handleScroll);
            //document.querySelector('body').setAttribute('style', 'background:#fff');
        },
        methods: {
            scroll() {
                var self = this;
                window.onscroll = () => {
                    let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
                    if (bottomOfWindow) {
                        self.getProducts();
                    }
                }
            },
            async fetchData() {
                var self = this;
                productApi.GetCategories().then(function (data) {
                    data.unshift({
                        id: '0',
                        name: 'Sugestões de listas',
                        children: [
                            { id: '3665', name: 'Utilitários' },
                            { id: '3667', name: 'Gourmet' },
                            { id: '3668', name: 'Happy Hour' },
                            { id: '3669', name: 'Chic' },
                            { id: '3670', name: 'Moderno' },
                            { id: '3671', name: 'Casual' },
                            { id: '3672', name: 'Must have!' },
                            { id: '3673', name: 'Eletros' },
                            { id: '3674', name: 'New in!' },
                            { id: '3675', name: 'Casamento' },
                            { id: '3676', name: 'Chá de Cozinha' },
                            { id: '3677', name: 'Chá Bar' },
                            { id: '3678', name: 'Aniversário' },
                            { id: '3666', name: 'Open House' },
                            { id: '3961', name: 'Até R$200' },
                            { id: '3962', name: 'Gift cards' },
                        ]
                    });
                    self.categories = data;
                });
                giftlistApi
                    .getGiftlistByUrl({ url: self.$route.params.urlText })
                    .then(function (data) {
                        console.log('get giftlist ' + data.data.id);
                        self.description = data.data.members;
                        self.city = data.data.city;
                        self.date = data.data.date;
                        self.id = data.data.id;
                        self.getGiftlistProducts();
                        self.type = data.data.type;
                    });
            },
            async clickCategory(departmentId, categoryId) {
                var self = this;
                self.categoriesVisible = false;
                self.products = [];
                self.page = 1;
                self.currentCategory = categoryId;
                self.currentDepartment = departmentId;
                self.getProducts();
				
            },
            async clickDepartment(departmentId) {
                var self = this;
                self.products = [];
                self.page = 1;
                self.currentCategory = '';
                self.currentDepartment = departmentId;
                self.getProducts();
            },
            async getProducts() {
                var self = this;
                if (self.currentDepartment == '' && self.currentCategory == '' && self.searchText == '') return;
                this.isBusy = true;
                if (self.currentDepartment != '0') {
                    self.giftlistSuggestionId = '';
                    productApi.searchProducts({ page: self.page, departmentId: self.currentDepartment, categoryId: self.currentCategory, search: self.searchText, ordination: self.ordination }).then(function (data) {
                        self.isBusy = false;
                        if (data == null || data.length == 0) self.reachEnd = true;
                        else self.reachEnd = false;
                        data.forEach((item) => {
                            item.alreadyIn = false;
                            item.addingToList = false;
							item.quantity = 1;
                            self.products.push(item);
                        });
                        self.checkIfProductsAlreadyIn();
                    });
                }
                else {
                    if (self.giftlistSuggestionId == self.currentCategory) {
                        self.isBusy = false;
                        return;
                    }
                    self.giftlistSuggestionId = self.currentCategory;
                    giftlistApi.getProducts({ giftlistId: parseInt(self.currentCategory) }).then(function (data) {
                        self.isBusy = false;
                        data.data.forEach((item) => {
                            if (item == null) return;
                            item.description = '';
                            item.imageUrl = '';
                            item.refCode = '';
                            item.hasListPrice = '';
                            item.listPrice = '';
                            item.price = '';
                            item.alreadyIn = false;
                            item.addingToList = false;
							item.quantity = 1;
                            self.products.push(item);
                            productApi.GetProduct({ skuid: item.skuid }).then(function (data2) {
                                if (data2 == null || data2.data == null) {
                                    self.removeProduct(item.skuid);
                                    return;
                                }
                                item.description = data2.data.description;
                                item.imageUrl = data2.data.imageUrl;
                                item.refCode = data2.data.refCode;
                                if (item.imageUrl == '' || item.imageUrl == null || item.description == null || item.description == '') {
                                    self.removeProduct(item.skuid);
                                    return;
                                }
                            });

                            priceApi.GetPrice({ skuid: item.skuid }).then(function (data) {
                                if (data == null || typeof (data) == 'undefined' || typeof (data.data) == 'undefined') {
                                    productApi.GetProductComplete({ skuid: item.skuid }).then(function (data) {
                                        item.description = data.description;
                                        item.imageUrl = data.imageUrl;
                                        item.refCode = data.reference;
                                        item.hasListPrice = data.hasListPrice;
                                        item.listPrice = data.listPrice;
                                        item.price = data.price;
                                    }, function (error) {
                                        //remove product
                                        self.removeProduct(item.skuid);
                                    });
                                    return;
                                }
                                item.hasListPrice = data.data.hasListPrice;
                                item.listPrice = data.data.listPrice;
                                item.price = data.data.price;
                            }, function (error) {
                                productApi.GetProductComplete({ skuid: item.skuid }).then(function (data) {
                                    item.description = data.description;
                                    item.imageUrl = data.imageUrl;
                                    item.refCode = data.reference;
                                    item.hasListPrice = data.hasListPrice;
                                    item.listPrice = data.listPrice;
                                    item.price = data.price;
                                }, function (error) {
                                    //remove product
                                    self.removeProduct(item.skuid);
                                });
                            });

                        });
                        self.checkIfProductsAlreadyIn();
                    });
					self.$gtag.event('clickSuggestion', { method: self.currentCategory });
                }
                self.page = self.page + 1;

            },
            async addProduct(product) {
                var self = this;
                product.addingToList = true;
                giftlistApi.addProductOrUpdate({ giftlistId: self.id, skuId: product.skuid, quantity: product.quantity }).then(function (data) {
                    product.alreadyIn = true;
                    product.addingToList = false;
                });
            },
            async removeProductFromList(product) {
                var self = this;
                product.addingToList = true;
                giftlistApi.deleteProduct({ giftlistId: self.id, skuId: product.skuid }).then(function (data) {
                    product.alreadyIn = false;
                    product.addingToList = false;
                });
            },
            removeProduct(skuid) {
                var self = this;
                for (var prodIndex = 0; prodIndex < self.products.length; prodIndex++) {
                    if (self.products[prodIndex].skuid == skuid) {
                        self.products.splice(prodIndex, 1);
                        console.log('removed:' + skuid);
                        break;
                    }
                }
            },
            addAllProductsFromList() {
                var self = this;
                self.products.forEach((item) => {
                    self.addProduct(item);
                });
            },
            getGiftlistProducts() {
                var self = this;
                giftlistApi.getProducts({ giftlistId: self.id }).then(function (data) {
                    console.log(data.data);
                    self.giftlistProducts = data.data;
                });
            },
            checkIfProductsAlreadyIn() {
                var self = this;
                for (var i = 0; i < self.products.length; i++) {
                    for (var j = 0; j < self.giftlistProducts.length; j++) {
                        if (self.products[i].skuid == self.giftlistProducts[j].skuid) {
                            self.products[i].alreadyIn = true;
                            break;
                        }
                    }
                }
            },
            async doSearch() {
                var self = this;
                self.categoriesVisible = false;
                self.products = [];
                self.page = 1;
                self.currentCategory = '';
                self.currentDepartment = '';
                self.getProducts();
            },
            async moreProducts() {
                this.getProducts();
            },
            handleScroll: function () {
                if (this.scTimer) return;
                this.scTimer = setTimeout(() => {
                    this.scY = window.scrollY;
                    clearTimeout(this.scTimer);
                    this.scTimer = 0;
                }, 100);
            },
            toTop: function () {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            },
        },
        watch: {
            products(newValue, oldValue) {
                if (newValue.length > 0) {
                    //document.body.classList.add('whitebody')
                    document.querySelector('body').setAttribute('style', 'background:#fff');
                }
                else {
                    //document.body.classList.remove('whitebody')
                    document.querySelector('body').removeAttribute('style');
                }
            },
            ordination(newValue, oldValue) {
                var self = this;
                self.products = [];
                self.page = 1;
                self.getProducts();
            }
        }
    }
</script>

<template>
    <Layout>


        <div class="row" style="background-color:#f1f1f1;">
            <div class="col-md-10 offset-md-1">
                <div class="card">
                    <div class="card-header custom">
                    </div>
                    <div class="card-body pt-2 pb-2">

                        <h5 class="mb-4 header-title">Buscar Produtos</h5>

                        <p>Para adicionar produtos, navegue nas categorias abaixo e então selecione os produtos desejados</p>

                        <p></p>
                        <p>Você está editando a lista {{type}} - {{description}}</p>
                        <p></p>

                        <b-button :class="categoriesVisible ? null : 'collapsed'" :aria-expanded="categoriesVisible ? 'true' : 'false'" aria-controls="collapse-categories" @click="categoriesVisible = !categoriesVisible">Exibir categorias</b-button>

                        <div class="form-inline ml-5 d-inline-block">
                            <b-form-group>
                                <b-form-input v-model="searchText" placeholder="Buscar..."></b-form-input>
                                <b-button @click="doSearch()" class="ml-1">Buscar</b-button>
                            </b-form-group>
                        </div>

                        <div v-if="currentDepartment != '0' && currentDepartment != ''" class="form-inline ml-5 d-inline-block">
                            <b-form-select v-model="ordination" class="mb-2">
                                <option value="1">Ordenar por nome de A-Z</option>
                                <option value="2">Ordenar por nome de Z-A</option>
                                <option value="3">Ordenar por preço Menor-Maior</option>
                                <option value="4">Ordenar por preço Maior-Menor</option>
                                <option value="5">Ordenar por mais vendidos</option>
                                <option value="4">Ordenar por data de lançamento</option>
                            </b-form-select>
                        </div>

                        <b-collapse id="collapse-categories" v-model="categoriesVisible" class="mt-2">

                            <p v-if="noProducts">Nenhum produto encontrado</p>

                            <div>
                                <b-tabs content-class="mt-3">
                                    <b-tab v-for="department in categories" :key="department.id" :title="department.name" @click="clickDepartment(department.id)">
                                        <ul class="list-group d-flex flex-row flex-wrap">
                                            <li v-for="category in department.children" :key="category.id" class="list-group-item list-group-item-noborder col-xs-6 col-sm-4 col-md-3">
                                                <b-link class="text-dark" href="#" @click="clickCategory(department.id, category.id)">{{category.name}}</b-link>
                                            </li>
                                        </ul>
                                    </b-tab>
                                </b-tabs>
                            </div>


                        </b-collapse>


                    </div>
                </div>
            </div>
        </div>

        <div class="mt-10 mb-10 text-center" v-if="giftlistSuggestionId != ''">
            <b-button class="d-inline mt-5 mb-5" @click="addAllProductsFromList">Adicionar todos os produtos da lista</b-button>
        </div>

        <div id="gcontent" class="ext pdpto">

            <div class="int">
                <div class="lista-produtos">
                    <div class="gt-produtos">
                        <div class="main">
                            <div class="vitrine resultItemsWrapper">
                                <div class="gt-vitrine prateleira">
                                    <div class="gt-vitrine prateleira n4colunas">
                                        <ul>

                                            <template v-for="(product, index) in products">
                                                <li :key="index" v-show="product.imageUrl != ''">
                                                    <Spinner :loading="product.addingToList" />
                                                    <div class="fotoProduto">
                                                        <a href="javascript:void(0)" v-bind:rel="product.skuid" class="espiar-produto">
                                                            <img v-bind:src="product.imageUrl" width="370" height="370" v-bind:alt="product.skuid" id="">
                                                        </a>
														<div>
															<input v-if="!product.alreadyIn" class="quantity" type="text" v-model="product.quantity" />
														</div>
                                                        <div class="show-buy">
                                                            <div class="add-list">
                                                                <div v-if="!product.alreadyIn" class="buy-button-normal buy-button-all bb-count-1" id="55923" name="55923">
                                                                    <a class="buy-button-normal-a55923 buy-button-all-a55923" href="javascript:void(0)" @click="addProduct(product)" v-bind:title="product.description">
                                                                        <span class="buy-sku-name">{{product.description}}</span>
                                                                    </a>
                                                                </div>
                                                                <div v-if="product.alreadyIn" class="alreadyin" href="javascript:void(0)" title="Clique para remover" style="cursor:pointer;" @click="removeProductFromList(product)">
                                                                    Adicionado à lista!
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h3 class="nome"><a>{{product.description}}</a></h3>
                                                    <div class="refProd">
                                                        <div class="product-field product_field_31 product-field-type_1">
                                                            Referencia
                                                            <ul><li v-bind:class="product.refCode">{{product.refCode}}</li></ul>
                                                        </div>
                                                    </div>
                                                    <div class="preco">
                                                        <span v-if="product.hasListPrice" class="preco-de">{{product.listPrice}}</span>
                                                        <span class="preco-por">{{product.price}}</span>
                                                    </div>
                                                    <div class="produtos-disponiveis d-verificado">
                                                        <span v-if="product.alreadyIn && false" class="atingidos">Adicionado à lista!</span>
                                                    </div>
                                                </li>
                                                <li v-if="(index + 1) % 4 == 0" :key="`${index}-divider`" class="helper_divider"></li>
                                            </template>


                                        </ul>
                                        <div class="mt-10 mb-10 text-center" v-if="!isBusy && !reachEnd && (currentDepartment != '' || currentCategory != '' || searchText != '')">
                                            <b-button class="d-inline mt-5 mb-5" @click="moreProducts">Ver mais</b-button>
                                        </div>
                                        <Spinner :loading="isBusy" :relative="true" />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- lista produtos -->
                </div>
            </div>
        </div>

        <transition name="fade">
            <div id="pagetop" class="fixed text-center" v-show="scY > 300" @click="toTop">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                     stroke="#4a5568"
                     stroke-width="1" stroke-linecap="square" stroke-linejoin="arcs" role="button">
                    <path d="M18 15l-6-6-6 6" />
                </svg>
            </div>
        </transition>

    </Layout>
</template>


<style lang="scss">
  @import '../../../../designScoped/shelf.scss';
</style>

<style scoped>


.list-group-item-noborder {
	border:none;
  padding: 0.25rem 0.55rem;
}

.ext {
  text-align: center;
}

.ext,.line {
    float: none;
    clear: both
}

.int {
  margin: 0 auto;
  text-align: left;
  position: relative;
  max-width: 1170px;
}

.show-buy .add-list a::before {
  content: 'Adicionar';
}

.whitebody {
  background-color: #fff !important;
}

.alreadyin {
  color: #1a971e;
  font-weight: bold;
  font-size: 1.2em;
  background: #f9f9f9;
  border-radius: 15px;
  display: inline-block;
  padding: 5px 10px;
  border: 1px solid #ededed;  
}

input.quantity {
	border-radius: 5px;
    border: 1px solid;
    width: 50px;
    text-align: center;
    font-weight: bold;
}

</style>



